import { ResponseCartao } from './responseCartao';

export class ResponseVoucherInvalido {

    private cartao: ResponseCartao;
    private inconsistencia: string;

    public getCartao(): ResponseCartao {
        return this.cartao;
    }

    public setCartao(cartao: ResponseCartao): void {
        this.cartao = cartao;
    }

    public getInconsistencia(): string {
        return this.inconsistencia;
    }

    public setInconsistencia(inconsistencia: string): void {
        this.inconsistencia = inconsistencia;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/responseVoucherInvalido.ts